import { AppConfig } from './app-config.package';

const config = new AppConfig();

export { type IConfig } from './libs/interfaces/interfaces';
export { config };
